import { defineMessages } from "@/i18n";
import en from "./en";

export const agentActivityUiMessages = defineMessages("agent-activity-ui", en);
